import { FormControl } from '../../../components/FormUtilities'
import InputField from '../../../components/InputField'
import { formPaymentConcept } from '../storage'

export default function Form() {
    const { getError, props } = formPaymentConcept.useInput('name')
    const helper = getError(
        'ERROR-0000102',
        'Ya existe un concepto con el mismo nombre'
    )
    return (
        <FormControl label="Nombre de concepto de pago" required>
            <InputField
                placeholder="Ingresar nombre"
                autoFocus
                {...props}
                helper={helper || props.helper}
            />
        </FormControl>
    )
}
